import styled from 'styled-components';

import { device } from 'common/constants/mediaQueries';

export const inputContainer = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  /* overflow: hidden; */
  border-radius: 12px;

  &.error {
    input {
      border: 1px solid var(--danger) !important;
    }
  }

  &.success {
    input {
      border: solid 1px var(--green-dark);
    }
  }
`;

export const input = styled.input<{ arrow?: boolean }>`
  padding: 0 20px;
  height: 54px;
  width: -webkit-fill-available;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  background: #fdfdfd;
  border: 1px solid rgba(182, 182, 182, 0.2);
  border-radius: 10px;
  color: var(--dark);

  /* &:focus ~ .input-label,
  &:not(:placeholder-shown) ~ .input-label {
    top: 0px;
    font-size: 11px;
  } */

  &:focus {
    border: 1px solid var(--primary-green);
    outline: none;
  }

  &:not(:placeholder-shown) ~ .input-label {
    color: #367af7;
  }

  @media ${device.tablet} {
    font-size: 14px;
  }
  @media ${device.mobileS} {
    font-size: 12px;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: ${({ arrow }) => (arrow ? 'auto' : 'none')};
    margin: 0;
  }

  /* Firefox */
  /* &[type="number"] {
    -moz-appearance: textfield;
  } */
`;

export const label = styled.label`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: var(--dark);
  padding-bottom: 5px;

  @media ${device.mobileL} {
    font-size: 14px;
    line-height: 20px;
  }
  @media ${device.mobileM} {
    font-size: 12px;
    line-height: 16px;
  }
  @media ${device.mobileS} {
    font-size: 10px;
    line-height: 14px;
  }
`;

export const message = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  color: var(--dark-light);
  padding-left: 10px;
  margin-top: 5px;

  &.error-message {
    color: var(--danger);
  }

  &.success-message {
    color: var(--green-dark);
  }
`;

export const img = styled.img`
  &.icon {
    position: absolute;
    right: 10px;
    bottom: 0;
    top: 0;
    margin: auto;

    @media ${device.mobileS} {
    }
  }
`;

export const InputBox = styled.div`
  position: relative;
  // margin-bottom: 5px;
`;

export const Icon = styled.div`
  position: absolute;
  right: 5px;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
`;
